var exports = {
  "k": "xfd349460--84c93e--container",
  "w": "xfd349460--84c93e--agents-title",
};

module.exports = exports;
